module.exports = __webpack_public_path__ + "static/img/a55_c.39bac69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/devices/a55_c.png
// module id = wlpM
// module chunks = 0